import script from "./CensadoChart.vue?vue&type=script&setup=true&lang=js"
export * from "./CensadoChart.vue?vue&type=script&setup=true&lang=js"

import "./CensadoChart.vue?vue&type=style&index=0&id=621d116e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-621d116e"]])

export default __exports__